<template>
  <div class="page">
    <div class="header">
      <div class="navTitle">个人中心</div>
      <div class="userInfo">
        <div class="avater">
          <img :src="userInfo.userphoto" alt="" v-if="userInfo.userphoto != null && userInfo.userphoto != ''" />

          <img src="../assets/new/avater.png" alt="" v-else />
          <div class="box_1">
            <div class="name">{{ userInfo.realName }}</div>
            <div class="phone" v-if="userInfo.mobile != '' && userInfo.mobile != null">
              <div class="icon_1"><img src="../assets/new/Vector.svg" alt="" /></div>
              {{ userInfo.mobile }}
            </div>
          </div>
        </div>

        <div class="box_2" @click="handleUserinfo">
          个人资料
          <div class="icon_2"><img src="../assets/new/right (2).png" alt="" /></div>
        </div>
      </div>
      <div class="group_1">
        <div class="vip">
          <div class="money">
            <div class="text_1">账户余额</div>
            <div v-if="userInfo.balance">{{ Number(userInfo.balance).toFixed(2) || 0 }}<span class="text_2">元</span></div>
            <div v-else>0<span class="text_2">元</span></div>
          </div>
          <div class="balance" @click="handleBalance">余额明细</div>
        </div>
        <div class="box_3">
          <div class="text_3">个人服务</div>
          <div class="li">
            <div class="li_1" @click="gotoStudy">
              <img src="../assets/new/Group 1277.svg" alt="" />
              <div class="text_4">我的学习</div>
            </div>
            <div class="li_1" @click="handleCertificate">
              <img src="../assets/new/Group 1278.svg" alt="" />
              <div class="text_4">我的证书</div>
            </div>
            <div class="li_1" @click="handleOrder">
              <img src="../assets/new/Group 1280.svg" alt="" />
              <div class="text_4">我的订单</div>
            </div>
            <div class="li_1" @click="handleMember">
              <img src="../assets/new/Group 1281.svg" alt="" />
              <div class="text_4">会员权益</div>
            </div>
          </div>
        </div>
        <div class="box_4">
          <!-- <div class="li_2">
            <div class="li_left">
              <div class="icon_3"><img src="../assets/new/Group 151.svg" alt="" /></div>
              <span class="text_5">我的收藏</span>
            </div>
            <div class="li_right">
              <img src="../assets/new/right (2).png" alt="">
            </div>
          </div> -->
                <div class="li_2" @click="handleJifen">
            <div class="li_left">
              <div class="icon_3"><img src="../assets/images/icon_77.png" alt="" /></div>
              <span class="text_5">我的积分</span>
            </div>
            <div class="li_right">
              <img src="../assets/new/right (2).png" alt="" />
            </div>
          </div>
          <div class="li_2" @click="handleInvoice">
            <div class="li_left">
              <div class="icon_3"><img src="../assets/new/Group 1162.svg" alt="" /></div>
              <span class="text_5">我的发票</span>
            </div>
            <div class="li_right">
              <img src="../assets/new/right (2).png" alt="" />
            </div>
          </div>
          <div class="li_2" style="border: 0" @click="handleKefu">
            <div class="li_left">
              <div class="icon_3"><img src="../assets/new/Group 279.svg" alt="" /></div>
              <span class="text_5">客服中心</span>
            </div>
            <div class="li_right">
              <img src="../assets/new/right (2).png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 退出登录 -->
      <div class="goOut">
        <van-button style="width: 160px; height: 48px; background: #ffffff; border-radius: 8px 8px 8px 8px; border: 0" @click="outlogin"
          >退出当前账号</van-button
        >
      </div>
    </div>

    <bottomNav></bottomNav>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import bottomNav from './component/tabBar.vue';
import { toPersonalCenter, doLogout } from '../api/my';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    bottomNav
  },
  data() {
    // 这里存放数据
    return {
      userInfo: {},
      isMember: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //去积分页
    handleJifen(){
       this.$router.push({
        path: '/jifen'
      });
    },
    //获取用户信息
    getUser() {
      toPersonalCenter().then(res => {
        this.userInfo = res.data.data;
        this.isMember = res.data.data.isMember;
      });
    },
    //退出登录
    outlogin() {
      this.$utils
        .showConfirm({
          title: '温馨提示',
          message: '确定要退出登录吗?'
        })
        .then(() => {
          doLogout().then(res => {
            if (res.data.code == '200') {
              localStorage.removeItem('token');
              this.$utils.showToast('退出登录成功');
              setTimeout(() => {
                this.$router.push({
                  path: '/login'
                });
              }, 1000);
            } else {
              this.$utils.showToast('退出失败');
            }
          });
        })
        .catch(() => {});
    },
    //去个人资料
    handleUserinfo() {
      this.$router.push({
        path: '/userInfo'
      });
    },
    //去余额明细
    handleBalance() {
      this.$router.push({
        path: '/balance'
      });
    },
    //去我的订单
    handleOrder() {
      this.$router.push({
        path: '/myOrder'
      });
    },
    //去我的学习
    gotoStudy() {
      this.$router.push({
        path: '/myClass'
      });
    },
    //去我的发票
    handleInvoice() {
      this.$router.push({
        path: '/myInvoice'
      });
    },
    //去客服中心
    handleKefu() {
      window.location.href = 'https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=安徽继续教育网';
    },
    //去我的证书
    handleCertificate() {
      this.$router.push({
        path: '/certificate'
      });
    },
    //去会员权益
    handleMember() {
      if (this.isMember == '02') {
        this.$utils
          .showConfirm({
            title: '温馨提示',
            message: '您已开通年度会员，是否前往课程资源库进行学习？'
          })
          .then(() => {
            this.$router.push({
              path: '/resource'
            });
          })
          .catch(() => {
            // this.$router.go(-1);
          });
      } else {
        this.$router.push({
          path: '/membership'
        });
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUser();
      window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
       
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
}
.header {
  height: 174px;
  background: linear-gradient(180deg, #2a70f2 -68%, #f6f8fa 100%);
}
.navTitle {
  width: 100%;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333333;
  padding-top: 20px;
}
.userInfo {
  display: flex;
  height: 48px;
  display: flex;
  margin-top: 25px;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
}
.avater {
  display: flex;
}
.box_1 {
  width: 200px;
  margin-left: 12px;
  .name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    width: 241px;
    margin-bottom: 5px;
  }
  .phone {
    width: 94px;
    height: 20px;
    background: rgba(42, 112, 242, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2a70f2;
    .icon_1 {
      width: 12px;
      height: 12px;
      background: linear-gradient(146deg, #2a70f2 0%, #699eff 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 6px;
        height: 6px;
      }
    }
  }
}
.box_2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #667280;
  display: flex;
  .icon_2 {
    width: 12px;
    height: 12px;
    img {
      width: 12px;
      height: 12px;
    }
  }
}
.group_1 {
  display: flex;
  flex-direction: column;
  // align-items: center;
  padding: 15px;
  margin-top: 26px;
}
.vip {
  // width: 345px;
  height: 48px;
  background: #393d4f;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  .money {
    font-family: DIN, DIN;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    .text_1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #f8dcb1;
    }
    .text_2 {
      font-size: 10px;
    }
  }
  .balance {
    width: 72px;
    height: 26px;
    background: #f8dcb1;
    border-radius: 14px 14px 14px 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    text-align: center;
    color: #4a4f63;
  }
}
.box_3 {
  // width: 345px;
  height: 130px;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 16px 15px;
  .text_3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
  }
  .li {
    margin-top: 22px;

    display: flex;
    justify-content: space-between;
    .li_1 {
      // width: 48px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        height: 28px;
        width: 28px;
      }
      .text_4 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 8px;
      }
    }
  }
}
.box_4 {
  // width: 345px;
  // height: 187px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  margin-top: 10px;
  padding: 4px 15px 0 15px;
  .li_2 {
    height: 61px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;
    .li_right {
      width: 12px;
      height: 12px;
      img {
        width: 12px;
        height: 12px;
      }
    }
    .li_left {
      display: flex;
      .text_5 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #333333;
        margin-left: 12px;
      }
    }
    .icon_3 {
      width: 18px;
      height: 18px;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
.goOut {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #999999;
}
</style>
